module.exports = __webpack_public_path__ + "img/14.bf9ff931.png";